import React, { Component } from "react";
import Subjektif from "../form/Subjektif.js";
import Objektif from "../form/Objektif.js";
import Assesment from "../form/Assesment";
import Planning from "../form/Planning.js";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import OdontogramSet from "./modules/odontogram-module/OdontogramSet";
import TableRiwayatOdontogram from "./TableRiwayatOdontogram";
import { OdontogramContext } from "../../context";
import ApiConsumer from "./ApiConsumer";
import "react-tabs/style/react-tabs.css";
import Table from "../component/Table.js";
import Card from "../component/Card.js";
import apiService from "apiService.js";
import printJS from "print-js";
import { confirmedAlert, toast } from "../component/Alert";
import ExternalIntraOral from "./modules/ExternalIntraOral";
import API from "../../apiService";
import BlobPrint from "view/component/BlobPrint.js";
import BodyParts from "view/kulit/BodyParts.js";

export default class Gigi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visitId: 1000,
      modules: [
        { id: "1", name: "Subjektif" },
        { id: "2", name: "Objektif" },
        { id: "3", name: "Assesment" },
        {
          id: "4",
          name: "Planning",
        },
      ],
      odontogramDatas: "",
      odontogramHistories: "",
      toothStatusDatas: "",
      tabIndex: 0,
      detilPx: this.props.detilPx,
      isDeleting: false,
      externalIntraOralData: null,
    };
    this.parentCallback = this.parentCallback.bind(this);
    this.nextTab = this.nextTab.bind(this);
  }

  componentDidMount() {
    ApiConsumer.getTeethAnamneseByPatient(this.props.detilPx.patients.id).then(
      (res) => {
        this.setState({
          odontogramDatas: res,
        });
      }
    );
    ApiConsumer.getRefTeeth().then((res) => {
      this.setState({
        toothStatusDatas: res,
      });
    });
  }

  handleHistoryClick = (element) => {
    const { odontogramDatas } = this.state;
    odontogramDatas &&
      this.setState({ odontogramHistories: odontogramDatas[element] });
  };

  handleTeethAnamneseSubmit = (element = null) => {
    ApiConsumer.getTeethAnamneseByPatient(this.props.detilPx.patients.id).then(
      (res) => {
        this.setState({
          odontogramDatas: res,
        });

        if (element) {
          this.setState({ odontogramHistories: res[element] });
        }
      }
    );
  };

  handleModalOpen = (nomenklatur) => {
    this.setState({
      modalShow: true,
    });
  };

  buttonClick = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  parentCallback(data) {
    this.setState((prevState) => ({
      detilPx: {
        // object that we want to update
        ...prevState.detilPx, // keep all other key-value pairs
        [data.param]: data.data,
      },
    }));
    // console.log(data);
  }

  nextTab() {
    const tabs = this.state.tabIndex;
    const tabIndex = tabs + 1;
    this.setState({ tabIndex: tabIndex });
  }
  getData = async () => {
    let param = {
      keyword: {
        visitId: this.state.detilPx.id,
      },
      limit: 10,
      frDate: "",
      enDate: "",
    };

    const res = await apiService.post("registration", param);
    // console.log(res)
    if (res?.status === "success.") {
      this.setState({
        detilPx: res.data.data[0],
      });
      this.forceUpdate();
    }
  };
  requestPrint = async () => {
    const res = await apiService.getblob(
      "/registration/print/informed_consent_gigi/" + this.state.detilPx.id
    );
    if (res) {
      const file = new Blob([res], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };
  delete_history = async (data) => {
    const that = this;
    confirmedAlert(
      "Info",
      "Apakah anda ingin menghapus data ini?",
      async function (confirmed) {
        if (confirmed) {
          that.setState({ isDeleting: true });
          const res = await apiService.delete(
            `/management/teeth_anamneses/delete/${data.id}`
          );
          if (res.code === 200) {
            that.getData();
            const x = await ApiConsumer.getTeethAnamneseByPatient(
              that.props.detilPx.patients.id
            );
            that.setState({ odontogramDatas: x });
            that.setState({ odontogramHistories: x[data.teeth_no] });

            toast({ status: "success", text: "berhasil menghapus data" });
          }
          that.setState({ isDeleting: false });
        }
      }
    );
  };
  render() {
    const { odontogramDatas, odontogramHistories, toothStatusDatas } =
      this.state;
    const patient = this.state.detilPx;

    return (
      <OdontogramContext.Provider
        value={{
          handleHistoryClick: this.handleHistoryClick,
          handleSubmit: (v) => {
            this.getData();
            this.handleTeethAnamneseSubmit(v);
          },
          patient: this.props.detilPx,
          toothStatusDatas,
          parentCallback: this.parentCallback,
        }}
      >
        <div>
          <div className="card">
            <div className="card-header">
              <div className="row align-items-center">
                <div className="col row">
                  <h4 className="h3 mb-0 ">Form Pemeriksaan Gigi</h4>
                  <div className="ml-2 mt--1">
                    <a
                      className="btn btn-sm btn-twitter btn-icon-only rounded-circle"
                      onClick={this.getData}
                    >
                      <i
                        className="fa fa-refresh"
                        style={{ color: "white" }}
                        aria-hidden="true"
                      ></i>
                    </a>
                  </div>
                  <div className="ml-2 mt--1">
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() => this.requestPrint()}
                    >
                      cetak persetujuan tindakan
                    </button>
                  </div>
                  <div className="ml-2 mt--1">
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() =>
                        BlobPrint(
                          "registration/print/informed_consent_gigi_ekstraksi/" +
                            this.state.detilPx.id
                        )
                      }
                    >
                      cetak persetujuan ekstraksi
                    </button>
                  </div>
                  <div className="ml-2 mt--1">
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() =>
                        BlobPrint(
                          "registration/print/informed_consent_gigi_devitalisasi/" +
                            this.state.detilPx.id
                        )
                      }
                    >
                      cetak persetujuan devitalisasi
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <Tabs
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex) => this.setState({ tabIndex })}
              >
                <TabList>
                  {/* <Tab id="Tubuh">Tubuh & Wajah </Tab> */}
                  <Tab id="Subjektif">Subjektif </Tab>
                  <Tab id="Objektif">Objektif </Tab>
                  <Tab id="Assesment">Assesment </Tab>
                  <Tab id="Planning">Planning </Tab>
                </TabList>
                {/* <TabPanel tabId="Tubuh">
                  <BodyParts patient={patient} />
                </TabPanel> */}
                <TabPanel tabId="Subjektif">
                  <Subjektif
                    patient={patient}
                    parentCallback={this.parentCallback}
                    history={this.props.history}
                    nextTab={this.nextTab}
                    getData={this.getData}
                  />
                </TabPanel>
                <TabPanel tabId="Objektif">
                  <Objektif
                    patient={patient}
                    parentCallback={this.parentCallback}
                    history={this.props.history}
                    nextTab={this.nextTab}
                    onExaminationSaved={async (_) => {
                      if (this.state.externalIntraOralData) {
                        // ternyata ini di apinya, sudah dicek apakah create atau update
                        await API.post(
                          "/management/teeth_external_intra_oral/create",
                          {
                            ...this.state.externalIntraOralData,
                            visit_id: this.state.detilPx.id,
                          }
                        );
                      }
                    }}
                  >
                    <div className="card">
                      <OdontogramSet
                        odontogramData={odontogramDatas}
                        openModal={this.handleModalOpen}
                        handleHistoryClick={this.handleHistoryClick}
                        nextTab={this.nextTab}
                      />
                    </div>
                    <div className="card">
                      <Card.ModuleHeader header="Riwayat Gigi" />
                      <Table
                        headers={[
                          "No",
                          "Tanggal",
                          "Diagnosa",
                          "Status Gigi",
                          "Tindakan",
                          "Catatan",
                          "",
                        ]}
                        data={odontogramHistories}
                        columnMapper={(data) => [
                          data.created_at,
                          Array.isArray(data.diagnose_name) ? (
                            data.diagnose_name.length === 1 ? (
                              data.diagnose_name
                            ) : (
                              <ul>
                                {data.diagnose_name.map((v) => (
                                  <li>{v}</li>
                                ))}
                              </ul>
                            )
                          ) : (
                            data.diagnose_name
                          ),
                          data.name,
                          Array.isArray(data.treatment_name) ? (
                            data.treatment_name.length === 1 ? (
                              data.treatment_name
                            ) : (
                              <ul>
                                {data.treatment_name.map((v) => (
                                  <li>{v}</li>
                                ))}
                              </ul>
                            )
                          ) : (
                            data.treatment_name
                          ),
                          data.catatan ?? "",
                          <button
                            className={"btn btn-sm btn-danger"}
                            onClick={() => this.delete_history(data)}
                            disabled={this.state.isDeleting}
                          >
                            <i className={"fa fa-trash"}></i>
                          </button>,
                        ]}
                        listsPerPage={5}
                      ></Table>
                    </div>
                    <div className="card">
                      <Card.ModuleHeader header="Pemeriksaan Eksternal Oral dan Intra Oral" />
                      <Card.Body>
                        <ExternalIntraOral
                          onDataChange={(data) =>
                            this.setState({ externalIntraOralData: data })
                          }
                          visit_id={this.state.detilPx.id}
                        />
                      </Card.Body>
                    </div>
                  </Objektif>
                </TabPanel>
                <TabPanel tabId="Assesment">
                  <Assesment
                    patient={patient}
                    parentCallback={this.parentCallback}
                    history={this.props.history}
                    nextTab={this.nextTab}
                    onIcdPosted={this.handleTeethAnamneseSubmit}
                  />
                </TabPanel>
                <TabPanel tabId="Planning">
                  <Planning
                    patient={patient}
                    parentCallback={this.parentCallback}
                    history={this.props.history}
                    nextTab={this.nextTab}
                    getData={this.getData}
                  />
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </OdontogramContext.Provider>
    );
  }
}
